import { useMemo } from 'react';
import { format, isBefore, isValid, parse } from 'date-fns';
export const useSafeParseDate = date => {
  return useMemo(() => {
    if (!date) return 'NA';
    const parsed = parse(date, 'yyyy-MM-dd', new Date());
    return isValid(parsed) ? format(parsed, 'LLLL d') : 'NA';
  }, [date]);
};
export const useSafeParseDateFormat = date => {
  return useMemo(() => {
    if (!date || !isValid(new Date(date))) return '';
    const parsed = parse(date, 'yyyy-MM-dd', new Date());
    return format(parsed, 'MM/dd/yyyy');
  }, [date]);
};
export const useIsDateBefore = date => {
  return useMemo(() => {
    if (!date || !isValid(new Date(date))) return false;
    return isBefore(new Date(), new Date(date));
  }, [date]);
};
//# sourceMappingURL=index.js.map